import './assets/styles/main.scss';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import Home from './pages/Home/Home';
import OrganizationLayout from './components/dashboardLayout/OrganizationLayout';
import AdminLayout from './components/dashboardLayout/AdminLayout';
import VolunteerLayout from './components/dashboardLayout/VolunteerLayout';
import AdminDashboard from './components/dashboard/admin/AdminDashboard';
import VolunteerDashboard from './components/dashboard/Volunteer/VolunteerDashboard';
import OrganizationDashboard from './components/dashboard/organization/OrganizationDashboard';
import OrganizationRequests from './components/dashboard/organization/OrganizationRequests';
import Message from './components/ui/Message';
import VolunteerRequest from './components/dashboard/Volunteer/VolunteerRequest';
import VolunteerTask from './components/dashboard/Volunteer/VolunteerTask';
import VolunteerCoupons from './components/dashboard/Volunteer/VolunteerCoupons';
import AdminRequest from './components/dashboard/admin/AdminRequest';
import OrganizationCoupons from './components/dashboard/organization/OrganizationCoupons';

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <AppLayout />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: 'organization',
          element: <Home />,
        },
        {
          path: 'volunteer',
          element: <Home />,
        },
        {
          path: 'organization/message',
          element: <Message />,
        },
        {
          path: 'volunteer/message',
          element: <Message />,
        },
      ],
    },

    {
      path: '/organization', 
      element: <OrganizationLayout />,
      children: [
        {
          path: 'dashboard', 
          element: <OrganizationDashboard />,
        },
        {
          path: 'requests', 
          element: <OrganizationRequests />,
        },
        {
          path: 'coupons', 
          element: <OrganizationCoupons />,
        },
      ],
    },

    {
      path: '/admin',
      element: <AdminLayout />,
      children: [
        {
          path: 'dashboard', 
          element: <AdminDashboard />,
        },
        {
          path: 'requests', 
          element: <AdminRequest />,
        },
      ],
    },

    {
      path: '/volunteer',
      element: <VolunteerLayout />,
      children: [
        {
          path: 'dashboard', 
          element: <VolunteerDashboard />,
        },
        {
          path: 'requests', 
          element: <VolunteerRequest />,
        },
        {
          path: 'tasks', 
          element: <VolunteerTask />,
        },
        {
          path: 'coupons', 
          element: <VolunteerCoupons />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
